import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  CardContent,
  CardMedia,
  Typography,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Button,
  Box,
  DialogContent,
  DialogTitle,
  DialogActions,
  Dialog,
  Stack,
  CircularProgress,
} from "@mui/material";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import MercadopagoIcon from "../../../assets/images/logo-mercadopago.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SuccessDialog from "../SuccessDialog";
import DialogRequestAllSeries from "./DialogRequestAllSeries";
import CartRepository from "../../../data/repository/CartRepository";
import ErrorDialog from "../ErrorDialog";
import LoginModal from "../LoginModal";
import { useAuth } from "../../contexts/AuthContext";
import { useCart } from "../../contexts/CartContext";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import CollateralRepository from "../../../data/repository/CollateralRepository";
import StripeLogo from "../checkout/stripeLogo";
import PointsRepository from "../../../data/repository/PoinstRepository";

const PointsDetailComponent = (props) => {
  const [t, i18n] = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const typeOfProduct = location.pathname.startsWith("/product/detail/")
    ? "product"
    : location.pathname.startsWith("/collateral/detail/")
    ? "collateral"
    : location.pathname.startsWith("/token/detail/")
    ? "token"
    : null;

  const { getCartList } = useCart();

  const collateralRepository = new CollateralRepository();
  const pointsRepository = new PointsRepository();
  const [product, setProduct] = useState(null);
  const [requestDialog, setRequestDialog] = useState(null);
  const [buyCollateralDialog, setBuyCollateralDialog] = useState({
    open: false,
    id: null,
  });
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [collateralAdquireLoading, setCollateralAdquireLoading] =
    useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [distanceTo, setDistanceTo] = useState("...");

  const { isAuthenticated, roles, userId } = useAuth();

  useEffect(() => {
    const fetchPointsDetail = async () => {
      try {
        const response = await pointsRepository.getPointProductById(id);
        setProduct(response[0]);
        console.log(response[0]);
      } catch (error) {
        console.error(error);
      }
    };
    fetchPointsDetail();
  }, []);

  const isImage = (url) => {
    return [".jpg", ".jpeg", ".png", ".gif"].some((ext) => url.endsWith(ext));
  };

  const openRequestDialog = () => {
    setRequestDialog(true);
  };

  const cartRepository = new CartRepository();

  const handleLoginClick = () => {
    setLoginModalOpen(true);
  };

  const handleAddProduct = async (tokenProductId) => {
    try {
      var productId = typeOfProduct === "token" ? tokenProductId : id;
      var tokenId = typeOfProduct === "token" ? id : null;
      const response = await cartRepository.addProduct(productId, tokenId);
      if (!response.success) {
        console.error(response.message);
        setError(
          response.message === "cart.error.00001"
            ? t("marketplace.tokenError1")
            : response.message === "cart.error.00002"
            ? t("marketplace.tokenError2")
            : response.message === "cart.error.00003"
            ? t("marketplace.tokenError3")
            : response.message === "cart.error.00006"
            ? t("marketplace.tokenError6")
            : response.message === "cart.error.00007"
            ? t("marketplace.tokenError7")
            : response.message === "cart.error.00008"
            ? t("marketplace.tokenError8")
            : response.message === "cart.error.00009"
            ? t("marketplace.tokenError9")
            : "Error: " + response.message
        );
        return;
      }
      setSuccess(t("productDetail.success"));
      getCartList();
    } catch (error) {
      setError(t("productDetail.error"));
    }
  };

  const handleAdquireCollateral = async (collateralId) => {
    setCollateralAdquireLoading(true);
    try {
      const response = await collateralRepository.adquireCollateral(
        collateralId
      );
      if (!response.success) {
        console.error(response.message);
        setError(
          response.message === "collateral.buy.error.00001"
            ? t("productDetail.adquireError1")
            : response.message === "collateral.buy.error.00002"
            ? t("productDetail.adquireError2")
            : response.message === "collateral.buy.error.00003"
            ? t("productDetail.adquireError3")
            : response.message === "collateral.buy.error.00004"
            ? t("productDetail.adquireError4")
            : response.message === "collateral.buy.error.00005"
            ? t("productDetail.adquireError5")
            : "Error: " + response.message
        );
        setBuyCollateralDialog({ open: false, id: null });
        setCollateralAdquireLoading(false);
        return;
      }
      setSuccess(t("productDetail.adquireSuccess"));
    } catch (error) {
      setError(t("productDetail.adquireError"));
    } finally {
      setBuyCollateralDialog({ open: false, id: null });
      setCollateralAdquireLoading(false);
    }
  };
  /* 
  t("productDetail.pointsTransfer", {
    points: product.points,
  }); */

  return (
    <Container
      maxWidth="xl"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "1rem",
      }}
    >
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} md={6}>
          <Container
            sx={{
              display: { xs: "flex", sm: "none" },
              width: "300px",
              height: "300px",
            }}
          >
            media
          </Container>
          <Container
            sx={{
              display: { xs: "none", sm: "flex" },
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <Swiper
              spaceBetween={10}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              modules={[FreeMode, Navigation, Thumbs]}
              className="swiper-product-bottom"
            >
              <SwiperSlide>
                <CardMedia
                  component="img"
                  image={product.thumbnail}
                  alt={product.title}
                  style={{ width: "100%", height: "100%" }}
                />
              </SwiperSlide>
            </Swiper>
          </Container>
        </Grid>
        <Grid item xs={12} md={6}>
          <CardContent>
            <Typography
              variant="h1"
              component="div"
              sx={{
                color: typeOfProduct === "token" ? "#450D5F" : "",
                fontWeight: "bold",
                fontSize: { xs: "20px", sm: "25px" },
                textTransform: "uppercase",
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              {product.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{ textAlign: { xs: "center", sm: "left" } }}
            >
              {product.description}
            </Typography>
            {/* {product.features && (
              <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
                <Table>
                  <TableBody>
                    {Object.entries(product.features)?.map(([key, value]) => (
                      <TableRow key={key}>
                        <TableCell
                          style={{
                            textTransform: "capitalize",
                            padding: "0.5rem 1rem",
                          }}
                        >
                          {t(`productDetail.${key.toLowerCase()}`)}
                        </TableCell>
                        <TableCell
                          style={{ padding: "0.5rem 1rem" }}
                          align="right"
                        >
                          {key === "presentation" && (
                            <>{product.features.presentation}</>
                          )}
                          {key !== "presentation" && value}
                        </TableCell>
                      </TableRow>
                    ))}
                    {typeOfProduct === "collateral" ? null : (
                      <TableRow>
                        <TableCell
                          style={{
                            textTransform: "capitalize",
                            padding: "0.5rem 1rem",
                          }}
                        >
                          {t(`productDetail.available`)}
                        </TableCell>
                        <TableCell
                          style={{ padding: "0.5rem 1rem" }}
                          align="right"
                        >
                          {distanceTo}
                        </TableCell>
                      </TableRow>
                    )}
                    {typeOfProduct === "token" ? (
                      <>
                        <TableRow>
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                              padding: "0.5rem 1rem",
                            }}
                          >
                            {t(`marketplace.seller`)}
                          </TableCell>
                          <TableCell
                            style={{ padding: "0.5rem 1rem" }}
                            align="right"
                          >
                            {product.user?.name}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                              padding: "0.5rem 1rem",
                            }}
                          >
                            {t(`marketplace.token`)}
                          </TableCell>
                          <TableCell
                            style={{ padding: "0.5rem 1rem" }}
                            align="right"
                          >
                            {product.tokenNumber}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                              padding: "0.5rem 1rem",
                            }}
                          >
                            {t(`marketplace.endDate`)}
                          </TableCell>
                          <TableCell
                            style={{ padding: "0.5rem 1rem" }}
                            align="right"
                          >
                            {product?.endDate?.date?.split(" ")[0]}
                          </TableCell>
                        </TableRow>
                      </>
                    ) : null}
                    {typeOfProduct === "collateral" ? (
                      <>
                        <TableRow>
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                              padding: "0.5rem 1rem",
                            }}
                          >
                            {t(`marketplace.liters`)}
                          </TableCell>
                          <TableCell
                            style={{ padding: "0.5rem 1rem" }}
                            align="right"
                          >
                            {product.liters}
                          </TableCell>
                        </TableRow>
                      </>
                    ) : null}
                  </TableBody>
                </Table>
              </TableContainer>
            )} */}

            <Box
              mt={2}
              display="flex"
              flexWrap="wrap"
              sx={{ flexDirection: { xs: "column", sm: "row" } }}
              gap={1}
            >
              {/*  {product.dataSheet && (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ maxHeight: "45px" }}
                  href={product.dataSheet}
                  className={`btn-outline-gradient ${
                    typeOfProduct === "token"
                      ? "btn-outline-gradient_token"
                      : ""
                  }`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("productDetail.technicalSheet")}
                </Button>
              )} */}
            </Box>
          </CardContent>
        </Grid>
      </Grid>

      <DialogRequestAllSeries
        open={!!requestDialog}
        onClose={() => setRequestDialog(null)}
        productId={id}
        productName={product.name}
      />

      <ErrorDialog
        open={!!error}
        onClose={() => setError(null)}
        alertTitle={t("productDetail.errorTitle")}
        alertMessage={error}
        dark={false}
        typeOfProduct={typeOfProduct}
      />

      <SuccessDialog
        open={!!success}
        onClose={() => setSuccess(null)}
        alertTitle={t("productDetail.infoTitle")}
        alertMessage={success}
        dark={false}
        typeOfProduct={typeOfProduct}
      />

      {!isAuthenticated ? (
        <LoginModal
          open={loginModalOpen}
          onClose={() => setLoginModalOpen(null)}
        />
      ) : (
        ""
      )}
    </Container>
  );
};

export default PointsDetailComponent;
